import React, { Component, createRef, useRef } from 'react'
import { Link, HashRouter } from 'react-router-dom'
import { setRegPage, currentWidget, popupOpenClose, setMobileTVPage, setDeviceConfigFailed, setFailScreen, openSMSWidget, setOpenProfileImage, setMultiSubWidget } from '../../action/action'
import { connect } from 'react-redux'
import { setRoomControlPage } from '../../layout2.0/action/action'
import { nonCompWidgetClick } from '../../layout2.0/JS/widgetHandling'
import { setExternalSignIn, setLoginRequired, setOpenDemoCamera } from '../../layout2.0/action/homeAction'
import { closeOrderPopUp } from '../../layout2.0/action/hCommerce2'
import { setHcommerceWidget } from '../../layout2.0/action/hCommerce2';
import { setDNDon, setMURon, setGoHome, setLoader } from '../../layout2.0/action/homeAction';
import { sendAcCommand } from '../../action/roomControlAction'
import { guestDetails, sendAnalytics } from '../../action/homeAction'
import { withTranslation } from 'react-i18next'
import { setOpenExternalLinkInSameTab } from '../../layout2.0/action/homeAction'
import { getCdnUrl } from '../../config/config'
import { CMSPath } from '../../config/constant'


class HorizontalMultipleLargeWidget extends Component {

    scrollContainerRef = createRef(); // Create a ref for the scrollable container

    state = {
        currentPage: 0
    };

    setRoomControlPageOnClick = (widget) => {
        switch (widget.widgetType) {
            case "Room Theme":
                this.props.setRoomControlPage("roomTheme");
                break;
            case "Room Temperature":
                this.props.setRoomControlPage("AcControl");
                break;
            case "Speaker":
                this.props.setRoomControlPage("speakerControl");
                break;
            case "Smart Window Control":
                this.props.setRoomControlPage("windowTintControl");
                break;
            default:
                console.log("no room control path is matching.")
                break;
        }
    }
    onWidgetClick = async (widget) => {
        let room = localStorage.getItem('room')
        console.log("current widget", widget)
        if (widget.path) {
            await this.props.currentWidget(widget);
            if (widget.path === "/RoomControl2") {
                this.setRoomControlPageOnClick(widget);
            }
            if (widget.path === "/mobileTv") {
                if (!room) {
                    if (process.env.REACT_APP_INROOMTAB == "true") {
                        this.props.setLoginRequired(true)
                    } else {
                        this.props.setRegPage(true);
                    }
                } else {
                    this.props.setMobileTVPage(true);
                }
            }
            if (widget.widgetType === "Hcommerce") {
                this.props.setHcommerceWidget(widget);
            }
            if (widget.path === "/happy") {
                if (this.props.survey.needsLogin)
                    if (!room || room === "null") {
                        if (process.env.REACT_APP_INROOMTAB == "true") {
                            this.props.setLoginRequired(true)
                        } else {
                            this.props.setRegPage(true);
                        }
                    }
            }
        } else {
            nonCompWidgetClick(widget, this.props)
        }
    }

    openSubWidgetList = () => {
        this.props.setMultiSubWidget(this.props.parentWidget);
    }
    updateCurrentPage = () => {
         
        const container = this.scrollContainerRef.current;
        // const containerWidth = container.clientWidth;
        
        const scrollLeft = container.scrollLeft;
        const itemWidth = container.querySelector('.tile-sm').clientWidth || 0;

        console.log("scrollLeft", scrollLeft)
        // Safeguard against division by zero
        if (itemWidth > 0) {
            const newPage = Math.round(scrollLeft / itemWidth);
            this.setState({ currentPage: newPage });
        }
    };

    handleScroll = () => {
        console.log("scrollH")
        this.updateCurrentPage();
    };



    componentDidMount() {
 
            console.log( this.scrollContainerRef.current, " this.scrollContainerRef.current")
            this.updateCurrentPage();
            window.addEventListener('resize', this.updateCurrentPage); // Update on resize
            this.scrollContainerRef.current.addEventListener('scroll', this.handleScroll);

      

    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateCurrentPage);
        this.scrollContainerRef.current.removeEventListener('scroll', this.handleScroll); // Fixed this line

    }


     
    render() {
        const { currentPage } = this.state;

        return (
            <div class="widgets margin-0">
                <div class="gallery-slides">
                    <div class="form-row-heading">
                        <h3 dangerouslySetInnerHTML={{__html: this.props.parentWidget.displayName}}></h3>
                        <Link class="inline-link" onClick={this.openSubWidgetList} to={"/MultiSubWidgetList"}>View All</Link>
                    </div>


                    <div class="multi-item-scroll"
                    
                     
                    >
                        <div class="multi-item"
                         ref={this.scrollContainerRef}
                         >

                            {this.props.widgetList.length > 0 ?
                                this.props.widgetList.map((iterator) => {
                                    return (
                                        <Link id={iterator.widgetType} className={`tile-sm thumbnails tile-container ${iterator.widgetMetaHtmlId ? iterator.widgetMetaHtmlId:""}`}
                                            onClick={() => {this.onWidgetClick(iterator) }}
                                            exact to={iterator.path ? iterator.path : "/"}
                                        >
                                            <div class="thumb-img">
                                                {iterator.compImage ?
                                                    <img 
                                                    // src={iterator.compImage}
                                                    src={getCdnUrl(CMSPath, iterator.btnImageUrl)}
                                                    ></img> :
                                                    ""
                                                }
                                            </div>

                                            <div class="thumb-text">
                                                <p class="thumb-heading" dangerouslySetInnerHTML={{__html: iterator.widgetTitle ? iterator.widgetTitle : ""}} ></p>
                                                <p dangerouslySetInnerHTML={{__html: iterator.widgetDesc ? iterator.widgetDesc : ""}}></p>
                                            </div>

                                            {iterator.buttonTitle && <div className="thumb-controls">
                                                <button className="primary">
                                                    {iterator.buttonTitle ? iterator.buttonTitle : ""}
                                                </button>
                                            </div>}
                                        </Link>
                                    )
                                }) : ""
                            }
                        </div>
                    </div>
                    <div className="page-indicator" style={{display:"none"}}>
                        {this.props.widgetList.map((_, index) => (
                            <span
                                key={index}
                                className={`dot ${currentPage === index ? 'active' : ''}`}
                            ></span>
                        ))}
                    </div>
                </div >
            </div>
        )
    }
}

HorizontalMultipleLargeWidget.defaultProps = {
    widgetList: []
}

const mapStateToProps = state => {
    return {
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidgets: state.store.sideNavBar.currentWidget,
        appLauncherWidget: state.store.appLauncher.widget,
        DND: state.store.InncomRoomControl.DND ?
            state.store.InncomRoomControl.DND : null,
        MUR: state.store.InncomRoomControl.MUR ?
            state.store.InncomRoomControl.MUR : null,
        streamingUrlFromConfig: state.store.home.clientConfig.doorCameraFeed ?
            state.store.home.clientConfig.doorCameraFeed.doorCameraFeedUrl : null,
        menuColor: state.store.home.MenuColor,
        currentHomePage: state.store2.currentHomePage,
        survey: state.store.survey,
        externalSignIn: state.store2.externalSignIn,
        roomControlSpecificVersion: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.roomControlSpecificVersion,

    }
}
export default connect(
    mapStateToProps,
    {
        currentWidget,
        popupOpenClose,
        setMultiSubWidget,
        openSMSWidget,
        setOpenProfileImage,
        setRoomControlPage,
        setDeviceConfigFailed,
        setOpenDemoCamera,
        setRegPage,
        closeOrderPopUp,
        setHcommerceWidget,
        setDNDon,
        setMURon,
        setOpenExternalLinkInSameTab,
        setMobileTVPage,
        sendAcCommand,
        sendAnalytics,
        setGoHome,
        setLoader,
        setFailScreen,
        setLoginRequired,
        guestDetails,
        setExternalSignIn
    }
)(withTranslation('translations')(HorizontalMultipleLargeWidget));